import { Grid2, Typography } from "@mui/material";
import CustomModalRegister from "components/concert/modalRegister";
import "./index.scss";
import { useRequestFinalizeRegister } from "hooks/event";
import useInfoContext from "hooks/useInfoContext";

const ModalFinalConfirm = ({ open, handleClose, step, setStep, clientInfo }) => {
  const { repToken, userIdRegistration } = useInfoContext();
  const { mutate: requestFinalizeRegister, isLoading } = useRequestFinalizeRegister();

  const userObject = Object.values(clientInfo?.registeredClients).find(
    (obj) => obj.clientInfo._id === userIdRegistration
  );
  const fullnameUser = userObject ? userObject.clientInfo.fullname : "نامشخص";

  
  const handleCancel = () => {
    handleClose();
  };

  const handleFinalConfirm = () => {
    if (repToken && userIdRegistration) {
      requestFinalizeRegister(
        {
          clientId: userIdRegistration,
          repToken: repToken,
        },
        {
          onSuccess: (response) => {
            if (response.status === "OK") {
              handleClose();
            }
          },
        }
      );
    }
  };

  return (
    <CustomModalRegister
      open={open}
      handleClose={handleClose}
      title="افزودن همراه"
      activeStep={step + 1}
      titleBody="تایید نهایی همراه شما"
      buttonFunction={handleFinalConfirm}
      buttonText="تایید نهایی"
      buttonFunctionCancel={handleCancel}
      buttonCancelText="لغو"
      companionName={fullnameUser}
      loadingButton={isLoading}
    >
      <Grid2 item size={{ xs: 12 }} className="container-final-confirm">
        <Typography variant="h6" className="description-final-confirm">
          رزرو کنسرت برای همراه شما انجام شده و رزرو مجدد توسط نامبرده امکان پذیر نمی‌باشد
          نامبرده در لیست رزرو شما ثبت می‌شود
        </Typography>
      </Grid2>
    </CustomModalRegister>
  );
};

export default ModalFinalConfirm;
